// extracted by css-extract-rspack-plugin
export default {"expandableArea":"_b5fb2d35","gradient":"_5d161f08"};